import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { AlertColor, Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const AlertContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: '4px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '12px 16px',
    minWidth: '300px',
    maxWidth: '400px',
    position: 'relative',
}));

const VerticalLine = styled(Box)<{ variant: AlertColor }>(({ theme, variant }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
    backgroundColor:
        variant === 'success' ? '#2e7d32' :
            variant === 'warning' ? '#ed6c02' :
                variant === 'error' ? '#d32f2f' :
                    '#22638D',
}));


const MessageContainer = styled(Box)(({ theme }) => ({
    justifyContent: "start",
    textAlign: "left",
}));



export type AlertVariant = 'success' | 'warning' | 'danger' | 'info';

export interface AlertProps {
    title?: string;
    subtitle?: string;
    variant?: AlertColor;
}

const KeydriveAlert: React.FC<AlertProps> = ({
    title,
    subtitle,
    variant = 'success',
}) => {

    const getIcon = () => {
        switch (variant) {
            case 'success':
                return <CheckCircleIcon fontSize="small" style={{ color: '#2e7d32' }} />;
            case 'warning':
                return <WarningIcon fontSize="small" style={{ color: '#ed6c02' }} />;
            case 'error':
                return <ErrorIcon fontSize="small" style={{ color: '#d32f2f' }} />;
            case 'info':
                return <InfoIcon fontSize="small" style={{ color: '#22638D' }} />;
            default:
                return <CheckCircleIcon fontSize="small" style={{ color: '#2e7d32' }} />;
        }
    };

    return (

        <AlertContainer sx={{ maxWidth: "100%" }}>
            <VerticalLine variant={variant} />
            <Avatar sx={{ backgroundColor: "#E9EFF4", width: "38px", height: "38px", justifyContent: "center", alignItems: "center", display: "flex", marginRight: "12px" }}>
                {getIcon()}
            </Avatar>
            <MessageContainer>
                    <Typography variant="body2" component="span" fontWeight="500" sx={{ mt: 0.5, textAlign: "left",  }}>
                        {title}
                    </Typography>
                    <Typography variant="body2" component="div" color="text.secondary" sx={{ mt: 0.5 }}>
                        {subtitle}
                    </Typography>
            </MessageContainer>
        </AlertContainer>
    );
};

export default KeydriveAlert;